import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["selects", "hiddenField", "fieldName"]
    static values = {
        data: Object, // holds the full tree
        overrideSelection: String,
        required: {type: Boolean, default: false},
    }

    connect() {
        if (this.hiddenFieldTarget.value.stringify != null) {
            this.path = JSON.parse(this.hiddenFieldTarget.value)

        } else {
            this.path = []
        }

        this.tree = this.dataValue // load full tree into memory
        this.loadOptions(this.tree, 0)
    }

    loadOptions(subtree, level) {
        if (Array.isArray(subtree))
            this.options = subtree
        else
            this.options = this.getKeys(subtree)

        this.removeSelectsFrom(level)

        if (this.options.length === 0) return

        const select = document.createElement("select")
        select.classList.add("text-gray-700", "cursor-pointer", "border", "rounded-lg", "p-2", "bg-white", "text-sm", "w-full", "mt-3")
        select.dataset.level = level
        select.dataset.action = "change->level-select#handleChange"

        select.innerHTML = `<option value="">Select...</option>`
        select.required = this.requiredValue
        this.options.forEach(option => {
            const opt = document.createElement("option")
            opt.value = option
            opt.textContent = option
            select.appendChild(opt)
        })

        this.selectsTarget.appendChild(select)
    }

    handleChange(event) {
        const level = parseInt(event.target.dataset.level)
        const selectedValue = event.target.value

        // Trim path to current level and add new value if present
        this.path = this.path.slice(0, level)
        if (selectedValue) {
            this.path.push(selectedValue)
        }

        // Update hidden input with current path
        if (this.path){
            let json = this.path?.length ? JSON.stringify(this.path) : null;

            this.hiddenFieldTarget.value = json
            this.fieldNameTarget.value = json
        }

        if (selectedValue == "Other") {
            const input = document.createElement("input")
            input.id = "other_input"
            input.classList.add("text-gray-700", "border", "rounded-lg", "p-2", "bg-white", "text-sm", "w-full", "mt-3")
            input.dataset.action = "change->level-select#changeText"
            input.dataset.level = level + 1
            this.selectsTarget.appendChild(input)
        } else {
            let subtree = this.tree
            if (this.path){
                for (const key of this.path) {
                    if (subtree && typeof subtree === "object") {
                        subtree = subtree[key]
                    }
                }
            }

            let outputElement = document.getElementById("other_input")
            if (outputElement) {
                outputElement.remove()
            }
            this.loadOptions(subtree, level + 1)
        }
    }

    changeText(event) {
        const level = parseInt(event.target.dataset.level)
        const selectedValue = event.target.value
        this.path = this.path.slice(0, level)
        if (selectedValue) {
            this.path.push(selectedValue)
        }
        if (this.path)
        {
            let json = this.path?.length ? JSON.stringify(this.path) : null;
            this.fieldNameTarget.value = json
        }
    }

    removeSelectsFrom(level) {
        // Remove selects deeper than the current level
        Array.from(this.selectsTarget.children).forEach(select => {
            if (parseInt(select.dataset.level) >= level) {
                select.remove()
            }
        })
    }

    getKeys(obj) {
        return obj && typeof obj === "object" ? Object.keys(obj) : []
    }
}